module.exports = __webpack_public_path__ + "static/media/student-summary-contender-next.cd6788e6.png";